import { render, staticRenderFns } from "./Systemname.vue?vue&type=template&id=bcd7d1ac&"
import script from "./Systemname.vue?vue&type=script&lang=js&"
export * from "./Systemname.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports